import React, { type ReactNode } from 'react';
import { Grid, Typography } from '@mui/material';

export type RowData = {
  label: ReactNode;
  value: ReactNode;
  boldLabel?: boolean;
};

export type AssessmentGridProps = {
  rows: RowData[];
  needHr?: boolean;
};

export const AssessmentGrid: React.FC<AssessmentGridProps> = props => {
  const { rows, needHr = false } = props;
  return (
    <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
      {rows.map((row, index) => (
        <React.Fragment key={index}>
          <Grid sx={{ wordWrap: 'break-word' }} size={6}>
            {row.boldLabel ? (
              <Typography variant="body2" fontWeight="bold">
                {row.label}
              </Typography>
            ) : (
              row.label
            )}
          </Grid>
          <Grid sx={{ wordWrap: 'break-word' }} size={6}>
            {row.value}
          </Grid>
          {needHr && index !== rows.length - 1 && (
            <Grid size={12}>
              <hr
                style={{
                  margin: '0.25rem',
                  backgroundImage:
                    'linear-gradient(to right, #fff, #ccc, #fff)',
                }}
              />
            </Grid>
          )}
        </React.Fragment>
      ))}
      {needHr && <hr />}
    </Grid>
  );
};
